import { Injectable } from '@angular/core';

import { AuthGuardConfig, RedirectCommandProvider } from '@guardfinder/shared';

import { RedirectStrategies } from '../../redirect-strategy/infrastructure/redirect-strategies';

@Injectable({
    providedIn: 'root'
})
export class AuthGuardConfigProviderService {
    private _authGuardConfig?: AuthGuardConfig;

    getConfig(): AuthGuardConfig {
        if (!this._authGuardConfig) {
            throw new Error('AuthGuardConfig not loaded');
        }
        return this._authGuardConfig;
    }

    async loadConfig(redirectCommandProvider: RedirectCommandProvider) {
        const command = await redirectCommandProvider.execute(RedirectStrategies.APP_INIT, {
            isClientLoggedIn: false
        });
        this._authGuardConfig = { defaultPath: command.path };
    }
}
